/**
 * @author Karthik <karthik.x@314ecorp.com>
 * @description Main pages
 */

import React from 'react';

import lazyRetry from '@admin-vite/utils/lazyRetry';

export const HomePageWithAuth = React.lazy(() => lazyRetry(() => import('@admin-vite/pages/HomePage')));
export const AssetsPageWithAuth = React.lazy(() => lazyRetry(() => import('@admin-vite/pages/AssetsPage')));
export const AssignmentPageWithAuth = React.lazy(() => lazyRetry(() => import('@admin-vite/pages/AssignmentPage')));
export const BroadcastPageWithAuth = React.lazy(() => lazyRetry(() => import('@admin-vite/pages/BroadcastPage')));
export const UserListPageWithAuth = React.lazy(() => lazyRetry(() => import('@admin-vite/pages/UserListPage')));
export const AnalyticsPageWithAuth = React.lazy(() => lazyRetry(() => import('@admin-vite/pages/AnalyticsPage')));
export const AiSearchPageWithAuth = React.lazy(() => lazyRetry(() => import('@admin-vite/pages/AiSearchPage')));

// Other pages
export const EditPageWithAuth = React.lazy(() => lazyRetry(() => import('@admin-vite/pages/EditPage')));
export const AssignmentsPageWithAuth = React.lazy(() => lazyRetry(() => import('@admin-vite/pages/AssignmentsPage')));
export const AssetPreviewPageWithAuth = React.lazy(() => lazyRetry(() => import('@admin-vite/pages/AssetPreviewPage')));
export const SystemStatusPageWithAuth = React.lazy(() => lazyRetry(() => import('@admin-vite/pages/SystemStatusPage')));

// Processing pages
export const ModeSelectionPage = React.lazy(() =>
	lazyRetry(() => import('@admin-vite/features/edit/components/ProcessingStage/ModeSelection')),
);
export const AISegmentationProcessingPage = React.lazy(() =>
	lazyRetry(() => import('@admin-vite/features/edit/components/ProcessingStage/AISegmentationProcessing')),
);
export const AIVideoGenerationProcessingPage = React.lazy(() =>
	lazyRetry(() => import('@admin-vite/features/edit/components/ProcessingStage/AIVideoGenerationProcessing')),
);
